export default class ImageHostPlaceholderDotCom {
  constructor() {
    this.GetImageUrlWithParams = _ref => {
      let {
        src,
        width,
        height
      } = _ref;
      let urlString = src;
      let apiParams = '';
      if (!urlString.endsWith('/')) {
        urlString = urlString.concat('/');
      }

      // Add any image modification parameters here
      if (width) {
        apiParams = apiParams.concat(`${width}x`);

        // height must come after width, so we only add height if width value exists.
        if (height) {
          apiParams = apiParams.concat(`${height}x`);
        }
      }

      // Append the parameters to the image URL
      if (apiParams.length > 0) {
        urlString = urlString.concat(apiParams).slice(0, -1); // remove trailing x
      }

      return urlString;
    };
  }
}